<template>
  <div class="d-flex content-center min-vh-100" style="background: url('/background/assets_ai_login.svg') no-repeat #4f4f4f; background-size: cover">
    <CRow>
      <CCol>
        <CCardGroup>
          <CCard class="p-4">
            <CCardBody>
              <CForm>
                <h1>Login</h1>
                <p class="text-muted">Sign In to your account</p>
                <CInput
                  placeholder="Username"
                  autocomplete="username email" v-model="email"
                >
                  <template #prepend-content><CIcon name="cil-user"/></template>
                </CInput>
                <CInput
                  placeholder="Password"
                  type="password"
                  autocomplete="curent-password" v-model="password"
                >
                  <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                </CInput>
                <CRow v-if="errorMessage">
                    <div id="loginStatus" class="mb-4 alert alert-warning animated fadeIn"><strong>Warning!</strong> {{ errorMessage }}</div>
                </CRow>
                <CRow>
                  <CCol col="6" class="text-left">
                    <CButton color="info" class="px-4" @click="doLogin()">Login</CButton>
                  </CCol>
                  <CCol col="6" class="text-right">
                    <CButton color="link" class="px-0 disabled">Forgot password?</CButton>
                  </CCol>
                </CRow>
              </CForm>
            </CCardBody>
          </CCard>
        </CCardGroup>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { auth } from '@/api'
import { isAuthenticated, logout, defaultPage } from '@/utils'

export default {
  name: 'Login',
  data () {
    return {
      email: "",
      password: "",
      errorMessage: "",
      successMessage: ""
    }
  },
  methods: {
    doLogin: function () {
      auth.login(this.email, this.password).then().then(async (result) => {
          if (result.status == 200) {
            localStorage.token = result.data.token
            localStorage.user = this.email

            if (result.data.token && result.data.token.split(".").length >= 3) {
              const data = JSON.parse(atob(result.data.token.split(".")[1]))
              localStorage.role = data.role
              localStorage.modules = data.modules
            }

            if (await isAuthenticated()){
              this.errorMessage = ""
              var defaultPage = localStorage.role == 'super' ? '/dashboard' : '/assets'

              if(localStorage.modules !== null && localStorage.role != 'super') {
                if(localStorage.modules.includes('tracking')) defaultPage = '/dashboard'
                else if(localStorage.modules.includes('poles')) defaultPage = '/poles'
                else if(localStorage.modules.includes('contractors')) defaultPage = '/contractors'
              }
              this.$router.replace(this.$route.query.redirect || defaultPage)
            }
          } else {
            logout()
            this.errorMessage = 'Unable to login'
          }
        }).catch((reason) => {
          logout()
          this.errorMessage = 'Unable to login'
          console.error(reason.message)
        })
    }
  }
}
</script>
